import { render } from "./ImageViewerComp.vue?vue&type=template&id=11b01a84"
import script from "./ImageViewerComp.vue?vue&type=script&lang=js"
export * from "./ImageViewerComp.vue?vue&type=script&lang=js"

import "./ImageViewerComp.vue?vue&type=style&index=0&id=11b01a84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__